function showMap() {
  $('#stage').show();
  $('#back').hide();
}

function addTicket(id, max, limit, fare_id) {
  console.log('addTicket', id, max, limit, fare_id);
  
  if ($('div[data-ticket-id=' + id + ']').length == max||$('div[data-ticket-id]').length>=limit) {
    alert('Máximo número de entradas permitidas');
      return false;
  }
  console.log('paso 2');
  
  var amount = $("#amount"+id+"_"+fare_id).val();  
  console.log('amount', amount);
  var ticket;
  for (var i = 0; i < amount; i++) {
    ticket = addTicketToList(id, fare_id);
    ticket.attr('onclick', 'removeTicket(' + ticket.data('ticket-number') + ')');
  }
  calculatePrice();
}

function removeTicket(ticketNumber) {
  removeTicketFromList(ticketNumber);
  calculatePrice();
}

function removeTicketFromList(ticketNumber) {
  $('[data-ticket-number=' + ticketNumber + ']').remove();
}

function deselectSeats() {
  $('[data-ticket-number]').remove();
  calculatePrice();
}
